import { AnyConceptStatusesByCid, FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import {
	ClaimHistoryConcept,
	ConceptStatusUpdate,
	getConceptStatusValue,
	RClaimDiagnosisCodeMap,
} from "@fusion-advantage/formlib"
import { FormThunk } from "../../redux/formStore"
import { err, ok, Result } from "neverthrow"
import z from "zod"
import { ComplexModelReduxPersister } from "./ComplexModelReduxPersister"
import { setFormModelClaimHistory } from "../../redux/formModelSlice"

export class ClaimHistoryModelReduxPersister implements ComplexModelReduxPersister {
	loadFromStatuses = (statusesByCid: AnyConceptStatusesByCid): FormThunk<Result<void, FusionError>> => (dispatch) => {
		const valueForCid = (cid: string) => getConceptStatusValue(statusesByCid[cid]) ?? []
		const rParse = z.array(RClaimDiagnosisCodeMap).safeParse(valueForCid(ClaimHistoryConcept.cid))
		if(!rParse.success) {
			return err(serializeFusionError('ClaimHistoryModelReduxPersister rParse', rParse.error))
		}
		dispatch(setFormModelClaimHistory(rParse.data))
		return ok()
	}
	shouldSave(): boolean {
		return false
	}
	createStatusUpdates(): ConceptStatusUpdate[] {
		return []
	}
}
